module.exports = __webpack_public_path__ + "img/email-pending.a1bf2d40.svg";